"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membershipInviteFactory = exports.membershipInvitePersonaFactory = exports.membershipInviteMembershipFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.membershipInviteMembershipFactory = Factory.Sync.makeFactory({
    cancel_date: null,
    display_name: 'Membership',
    effective_at: Mocks.dates.date2000,
    expires_at: Mocks.dates.date2100,
    id: Mocks.membership.id,
    membership_number: '1001',
    status: 'Active',
});
exports.membershipInvitePersonaFactory = Factory.Sync.makeFactory({
    email: Mocks.persona.email,
    first_name: Mocks.persona.first_name,
    last_name: Mocks.persona.last_name,
    name: Mocks.persona.full_name
});
exports.membershipInviteFactory = Factory.Sync.makeFactory({
    accepted_at: null,
    affiliation_organization_id: 530,
    created_at: Mocks.dates.date2000,
    created_by_user_id: 12345,
    email_address: Mocks.persona.email,
    expires_at: null,
    id: Factory.each(() => uuid_1.v4()),
    last_sent_at: Mocks.dates.date2100,
    membership: null,
    memberships: [],
    membership_definition_id: Factory.each(() => uuid_1.v4()),
    membership_ids: [],
    membership_id: null,
    organization_ids: [Mocks.orgClub.id, Mocks.orgNgb.id],
    persona: Object.assign(Object.assign({}, Mocks.persona), { name: Mocks.persona.full_name }),
    persona_id: '1',
    sent_by_org_id: Mocks.orgNgb.id,
    sent_by_persona_id: 2,
    status: 'pending',
    updated_at: Mocks.dates.date2000
});
